module.exports = __webpack_public_path__ + "static/img/image_solutions_precision_04.23d216f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/image_solutions_precision_04.png
// module id = fIEf
// module chunks = 10